// src/polyfills/dateDisplayPatch.js
// Force DD/MM/YYYY for date-only and 24-hour HH:mm:ss for datetime/time displays.
// Default date separator = '/'.

(function patchDateLocaleDisplay() {
  if (typeof Date === "undefined") return;

  const pad = (n) => String(n).padStart(2, "0");
  const DEFAULT_SEP = "/";

  function formatDDMMYYYY(date, sep) {
    return `${pad(date.getDate())}${sep}${pad(date.getMonth() + 1)}${sep}${date.getFullYear()}`;
  }

  function formatDateTime24(date) {
    return `${formatDDMMYYYY(date, DEFAULT_SEP)} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  }

  function formatTime24(date) {
    return `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  }

  /** Merge options so any hour/minute formatting is forced to 24-hour. */
  function forceHour12False(options) {
    if (!options || typeof options !== "object") return { hour12: false };
    return { ...options, hour12: false };
  }

  const ORIGINAL_DATE = Date.prototype.toLocaleDateString;
  if (ORIGINAL_DATE && !ORIGINAL_DATE.__patchedForDDMMYYYY) {
    function patchedDate() {
      try {
        if (arguments.length > 0) return ORIGINAL_DATE.apply(this, arguments);
      } catch (e) {
        // fall through
      }
      return formatDDMMYYYY(this, DEFAULT_SEP);
    }
    patchedDate.__patchedForDDMMYYYY = true;
    Date.prototype.toLocaleDateString = patchedDate;
  }

  const ORIGINAL_LOCALE = Date.prototype.toLocaleString;
  if (ORIGINAL_LOCALE && !ORIGINAL_LOCALE.__patchedFor24h) {
    function patchedLocale() {
      try {
        if (arguments.length === 0) return formatDateTime24(this);
        const locales = arguments[0];
        const options = forceHour12False(arguments[1]);
        // If caller only asked for date fields (no hour/minute), keep original date formatting.
        const opts = arguments[1];
        const asksTime =
          !opts ||
          opts.hour != null ||
          opts.minute != null ||
          opts.second != null ||
          opts.timeStyle != null ||
          (opts.dateStyle == null && opts.year == null && opts.month == null && opts.day == null);
        if (!asksTime && opts && (opts.year != null || opts.month != null || opts.day != null || opts.dateStyle != null)) {
          return ORIGINAL_LOCALE.call(this, locales, opts);
        }
        return ORIGINAL_LOCALE.call(this, locales, options);
      } catch (e) {
        return formatDateTime24(this);
      }
    }
    patchedLocale.__patchedFor24h = true;
    Date.prototype.toLocaleString = patchedLocale;
  }

  const ORIGINAL_TIME = Date.prototype.toLocaleTimeString;
  if (ORIGINAL_TIME && !ORIGINAL_TIME.__patchedFor24h) {
    function patchedTime() {
      try {
        if (arguments.length === 0) return formatTime24(this);
        const locales = arguments[0];
        const options = forceHour12False(arguments[1]);
        return ORIGINAL_TIME.call(this, locales, options);
      } catch (e) {
        return formatTime24(this);
      }
    }
    patchedTime.__patchedFor24h = true;
    Date.prototype.toLocaleTimeString = patchedTime;
  }
})();
